import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { FormGroup, Validators } from '@angular/forms';
import { LazyScrollableDataSource } from '@rappi/common';

import { CatalogItem, NewPurchaseOrderConfig } from '../../../../models/makers-finances-mgr.models';
import {
  DetailMode, SourceType,
  PO_FIELD, PO_FIELD_LABELS, PO_SECTION_LABELS, PO_SECTION,
} from '../../purchase-order.constants';
import { SelectOption, staticSourceFromCatalog } from '../section-base.types';

@Component({
  selector: 'app-section-additional-info',
  templateUrl: './section-additional-info.component.html',
  styleUrls: ['./section-additional-info.component.scss'],
})
export class SectionAdditionalInfoComponent implements OnInit, OnChanges {
  @Input() form: FormGroup;
  @Input() mode: DetailMode;
  @Input() sourceType: SourceType;
  @Input() remoteConfig: NewPurchaseOrderConfig | null;
  @Input() tagsCatalog: CatalogItem[] = [];
  @Input() catalogsLoaded = false;
  @Input() submitted = false;
  @Input() fieldConfigs: Record<string, any> = {};

  readonly F = PO_FIELD;
  readonly LABELS = PO_FIELD_LABELS;
  readonly sectionLabel = PO_SECTION_LABELS[PO_SECTION.ADDITIONAL_INFO];

  readonly selectConfig = { search: false, includeAll: false, showTotalsChip: false, maxNumberOfChips: 1, panelClass: '' };
  readonly tagsSelectConfig = { search: true, includeAll: false, showTotalsChip: true, maxNumberOfChips: 10, panelClass: '' };

  selectSources: Record<string, LazyScrollableDataSource<SelectOption>> = {};

  ngOnInit(): void {
    this.form.get(PO_FIELD.DETAIL_BRIEF)?.setValidators([Validators.maxLength(300)]);
    this.form.get(PO_FIELD.DETAIL_BRIEF)?.updateValueAndValidity({ emitEvent: false });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['remoteConfig'] && this.remoteConfig) {
      if (this.remoteConfig.request_reason_options?.length) {
        this.selectSources[PO_FIELD.REQUEST_REASON] = staticSourceFromCatalog(this.remoteConfig.request_reason_options);
      }
    }

    if (changes['tagsCatalog'] && this.tagsCatalog.length) {
      this.selectSources[PO_FIELD.TAGS] = staticSourceFromCatalog(this.tagsCatalog);
    }

  }

  get isRequestReasonVisible(): boolean {
    return !!this.fieldConfigs[PO_FIELD.REQUEST_REASON]?.visible_by_source?.[this.sourceType];
  }

  get isTagsVisible(): boolean {
    return !!(this.tagsCatalog?.length);
  }

  get detailBriefLength(): number {
    return (this.form?.get(PO_FIELD.DETAIL_BRIEF)?.value || '').length;
  }

  onSelectChange(fieldKey: string, value: SelectOption): void {
    this.form.get(fieldKey)?.setValue(value?.id ?? null);
  }

  onTagsChange(value: SelectOption | SelectOption[]): void {
    const ids = Array.isArray(value)
      ? value.map(v => v.id)
      : value ? [value.id] : [];
    this.form.get(PO_FIELD.TAGS)?.setValue(ids.length ? ids : null);
  }

  isInvalid(key: string): boolean {
    if (!this.submitted) return false;
    return !!this.form.get(key)?.errors?.['required'];
  }
}
